/* eslint-disable import/no-default-export */
import React, {useEffect, useRef, useState} from 'react';
import {useSpotlightTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import {animated} from '@react-spring/web';
import classnames from 'classnames';
import Markdown from 'markdown-to-jsx';
import styles from '@dazn/lp-web/src/components/CompetitionCarousal/competition-carousal.module.css';
import {ICompetitionCarousel} from '@dazn/lp-web/src/types';
import {ComponentTypes} from '../../constants/componentTypes.constants';

interface IProps {
    data: ICompetitionCarousel;
    disableAnimation: boolean;
}
const CompetitionCarousal: React.FC<IProps> = ({data, disableAnimation}) => {
    const {title, competitions, carouselInterval = 5000} = data;
    const [selected, setSelected] = useState(0);
    const hovered = useRef(false);
    const [refView, springs] = useSpotlightTransitions();

    useEffect(() => {
        const interval = setInterval(() => {
            if (hovered.current) {
                return;
            }
            setSelected(
                (prevSelected) => (prevSelected + 1) % competitions?.length
            );
        }, carouselInterval);
        return (): void => clearInterval(interval);
    }, [competitions]);

    const handleCompetitionClick = (index: number): void => {
        setSelected(index);
    };

    const animations = disableAnimation
        ? {}
        : {
              style: springs,
              ref: refView
          };

    if (!competitions?.length) {
        return null;
    }

    return (
        <div
            id={ComponentTypes.COMPETITION_CAROUSEL}
            className={styles.mainContainer}
            data-test-id="competition-carousel"
        >
            <animated.div {...(disableAnimation ? {} : {...animations})}>
                <Markdown className={styles.title}>{title}</Markdown>
            </animated.div>
            <div className={classnames(styles.logoContainer)}>
                {competitions?.map((competition: any, index: number) => (
                    <div
                        key={`competition-logo-${index + 1}`}
                        className={classnames(styles.imageContainer, {
                            [styles.selected]: selected === index,
                            [styles.gold]: competition.isHighlighted
                        })}
                        onClick={() => handleCompetitionClick(index)}
                        onMouseEnter={() => (hovered.current = true)}
                        onMouseLeave={() => (hovered.current = false)}
                    >
                        <img
                            src={competition?.logo?.src}
                            alt="Competition-logo"
                        />
                    </div>
                ))}
            </div>
            {competitions?.map((competition: any, index: number) => {
                if (index !== selected || !competition?.description) {
                    return null;
                }
                return (
                    <Markdown
                        key={`description-${index}`}
                        className={classnames(styles.description)}
                    >
                        {competition?.description}
                    </Markdown>
                );
            })}
        </div>
    );
};

export default CompetitionCarousal;
